import React from "react";
import NewsCard from "../../../moleculas/NewsCard";
import { NoticiaListItemVM } from "../../../../types/viewModels/cmsPublic";

export interface NewsGridProps {
  noticias: NoticiaListItemVM[];
  columnClassName?: string;
}

const NewsGrid: React.FC<NewsGridProps> = ({ noticias, columnClassName }) => (
  <div className="row w-100">
    {noticias.map((noticia) => (
      <div
        key={noticia.id}
        className={`${
          columnClassName || "col-lg-4 col-md-6 col-12"
        } mb-4 d-flex`}
      >
        <NewsCard noticia={noticia} />
      </div>
    ))}
  </div>
);

export default NewsGrid;
